import { Link } from "react-router-dom"
import { TOKEN_LOGO } from "@/lib/brand"

const STATS = [
  { label: "Ticker", value: "$KLIPO" },
  { label: "Network", value: "Robinhood Chain" },
  { label: "Pair", value: "ETH / KLIPO" },
  { label: "Rate", value: "1 ETH = 12,500 KLIPO" },
  { label: "Status", value: "Live in Swap" },
]

const UTILITY = [
  "Companion coin for the KLIPO feed on Robinhood Chain.",
  "Swap $KLIPO against $ETH from the in-app DEX.",
  "Image listings still settle in $ETH. $KLIPO is the hood coin beside the sale.",
  "Reels stay off-chain. Images mint, sell, transfer, or burn on-chain.",
]

export default function ReelTokenPage() {
  return (
    <div className="px-4 py-6">
      <div className="flex flex-col items-center text-center">
        <img
          src={TOKEN_LOGO}
          alt="$KLIPO"
          className="h-28 w-28 rounded-full object-cover shadow-[0_0_36px_rgba(0,255,102,0.35)]"
        />
        <p className="mt-5 text-[11px] uppercase tracking-[0.22em] text-[#6E6E6E]">KLIPO token</p>
        <h1 className="mt-1 font-[Syne] text-3xl font-bold">$KLIPO</h1>
        <p className="mt-2 max-w-xs text-sm leading-relaxed text-[#A8A8A8]">
          The token of the feed. $KLIPO is the in-app coin for KLIPO on Robinhood Chain, paired with $ETH.
        </p>
      </div>

      <dl className="mt-8 divide-y divide-[#1F1F1F] overflow-hidden rounded-2xl border border-[#1F1F1F] bg-[#0B0B0B]">
        {STATS.map((stat) => (
          <div key={stat.label} className="flex items-center justify-between gap-4 px-4 py-3.5">
            <dt className="text-xs uppercase tracking-[0.16em] text-[#6E6E6E]">{stat.label}</dt>
            <dd className="text-right text-sm font-medium text-white">{stat.value}</dd>
          </div>
        ))}
      </dl>

      <section className="mt-5 rounded-2xl border border-[#1F1F1F] bg-[#0B0B0B] p-4">
        <h2 className="text-sm font-semibold">Utility</h2>
        <ul className="mt-3 space-y-2 text-sm leading-relaxed text-[#A8A8A8]">
          {UTILITY.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="mt-5 rounded-2xl border border-[#1F1F1F] bg-[#0B0B0B] p-4">
        <h2 className="text-sm font-semibold">How to get $KLIPO</h2>
        <ol className="mt-3 list-decimal space-y-2 pl-4 text-sm leading-relaxed text-[#A8A8A8]">
          <li>Connect a wallet on Robinhood Chain.</li>
          <li>Open Swap and sell $ETH to buy $KLIPO, or the reverse.</li>
          <li>Keep $ETH ready for on-chain image sales. Use $KLIPO as the hood coin beside the feed.</li>
        </ol>
      </section>

      <div className="mt-6 grid grid-cols-2 gap-2">
        <Link
          to="/swap"
          className="flex items-center justify-center rounded-xl bg-[#00C805] py-3 text-sm font-semibold text-black"
        >
          Swap $KLIPO
        </Link>
        <Link
          to="/explore"
          className="flex items-center justify-center rounded-xl border border-[#1F1F1F] bg-[#141414] py-3 text-sm text-white"
        >
          Browse frames
        </Link>
      </div>
    </div>
  )
}
